import { PropsWithChildren } from 'react'
import { Footer } from '../footer'
import { NavigationBar } from '../navigation-bar'
import { NavigationBarStub } from '../navigation-bar-stub'
import * as styles from './with-layout.css.ts'

export const WithLayout = (props: PropsWithChildren) => {
  return (
    <>
      <NavigationBar />
      <div className={styles.siteContainer}>
        <main className={styles.main}>{props.children}</main>
        <Footer />
      </div>
    </>
  )
}

export const WithStubLayout = (props: PropsWithChildren) => {
  return (
    <>
      <NavigationBarStub />
      <div className={styles.siteContainer}>
        <main className={styles.main}>{props.children}</main>
        <Footer />
      </div>
    </>
  )
}
